"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _PropertyTypes = _interopRequireDefault(require("redux-less/constants/PropertyTypes"));

var isPropertyDefinedAndNotNull = function isPropertyDefinedAndNotNull(_ref) {
  var selected = _ref.selected,
      property = _ref.property;

  if (typeof property === "string") {
    return selected.get(property) && selected.get(property) !== null;
  } else if ((0, _typeof2.default)(property) === "object" && property.type) {
    if (property.type === _PropertyTypes.default.NESTED) {
      return property.children.find(function (child) {
        return isPropertyDefinedAndNotNull({
          selected: selected,
          property: child
        });
      });
    }

    return selected.get(property.key) && selected.get(property.key) !== null;
  }
};

var _default = isPropertyDefinedAndNotNull;
exports.default = _default;
module.exports = exports.default;